<template>
  <div class="com-box">
    <div class="field-item van-hairline--bottom top-radius" :class="{'bottom-radius': !form.boolShowRedPacket}">
      <div class="field-item-title bold">现金红包</div>
       <van-radio-group v-model="form.boolShowRedPacket" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange('red')">
        <van-radio :name="false">关闭</van-radio>
        <van-radio :name="true">开启</van-radio>
      </van-radio-group>
      <!-- <van-switch v-model="form.boolShowRedPacket" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/> -->
    </div>

    <template v-if="form.boolShowRedPacket">
      <!-- <div class="card"> -->
        <div class="field-item">
          <div class="field-item-title bold">地理限制</div>
          <!-- <van-switch v-model="form.boolAreaLimited" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/> -->
          <van-radio-group v-model="form.boolAreaLimited" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange">
            <van-radio :name="false">关闭</van-radio>
            <van-radio :name="true">开启</van-radio>
          </van-radio-group>
        </div>
        <div class="tips tips-bg van-hairline--bottom">开启地理位置限制后，仅限分享职员所在市区才能领取红包</div>
        <div class="field-item">
          <div class="field-item-title bold">红包领取轮播</div>
          <!-- <van-switch v-model="form.boolRedPacketRolling" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/> -->
          <van-radio-group v-model="form.boolRedPacketRolling" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange">
            <van-radio :name="false">关闭</van-radio>
            <van-radio :name="true">开启</van-radio>
          </van-radio-group>
        </div>
        <div class="tips tips-bg van-hairline--bottom">开启后，会在活动首页顶部滚动展示</div>
        <div class="field-item">
          <div class="field-item-title bold">屏蔽内部人员</div>
          <!-- <van-switch v-model="form.boolInternalStaffLimit" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/> -->
          <van-radio-group v-model="form.boolInternalStaffLimit" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange">
            <van-radio :name="false">关闭</van-radio>
            <van-radio :name="true">开启</van-radio>
          </van-radio-group>
        </div>
        <div class="tips tips-bg van-hairline--bottom">开启后，红包百分百不中奖，裂变佣金不发放</div>
      <!-- </div> -->
      
      <div class="field-item van-hairline--bottom top-radius">
        <div class="field-item-title bold">红包类型</div>
        <!-- <van-button v-if="isReadonly"
          color="#FF6B31" 
          size="mini">
          {{form.redPacketType | redPacketTypeEnum}}
        </van-button>
        <van-button  v-else color="#FF6B31" size="mini" @click="isShowPopover = true">
          {{form.redPacketType | redPacketTypeEnum}}
        </van-button> -->
        <van-radio-group :disabled="isReadonly" v-model="form.redPacketType" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange">
          <van-radio name="1">普通红包</van-radio>
          <van-radio name="2">随机红包</van-radio>
        </van-radio-group>
      </div>

      <!-- 普通红包 -->
      <van-field v-if="form.redPacketType == 1"
        class="fee-value text-input" 
        v-model="form.singleAmount" 
        label="单个金额"
        label-width="8.5em"
        placeholder="最小0.3元，保留两位小数" 
        type="number"
        :readonly="isReadonly"
        @blur="checkFeeValid('singleAmount')">
        <span slot="right-icon">元</span>
      </van-field>
      <van-field class="fee-value text-input bottom-radius" 
        v-model="form.totalAmount" 
        label="首次充值金额"
        label-width="8.5em"
        placeholder="最小0.3元，保留两位小数"
        type="number"
        :readonly="isReadonly"
        @blur="checkDecimalPlaces('totalAmount')">
        <span slot="right-icon">元</span>
      </van-field>
      <div class="tips mt-5">因微信手续费问题，请以实际到账金额为准</div>

      <!-- 随机红包 -->
      <template v-if="form.redPacketType == 2">
        <div class="range-card" v-for="(rangeItem, index) in form.ranges" :key="index">
          <div class="range-card-head van-hairline--bottom">
            <span>红包区间{{index + 1}}</span>
            <van-icon v-if="form.ranges.length > 1 && !isReadonly" name="clear" size="18" color="#F23D20" @click="deleteRange(index)"/>
          </div>
          <div class="range-card-content">
            <div class="range-field">
              <div class="range-field-label">金额区间</div>
              <div class="range-field-content">
                <van-field class="range-input" 
                  v-model="rangeItem.startAmount"
                  placeholder="保留两位小数" 
                  type="number"
                  :readonly="isReadonly"
                  @blur="checkFeeValid('startAmount', rangeItem)">
                  <span slot="right-icon">元</span>
                </van-field>
                <span>~</span>
                <van-field class="range-input" 
                  v-model="rangeItem.endAmount"
                  placeholder="保留两位小数" 
                  type="number"
                  :readonly="isReadonly"
                  @blur="checkFeeValid('endAmount', rangeItem)">
                  <span slot="right-icon">元</span>
                </van-field>
              </div>
            </div>
            <div class="range-field">
              <div class="range-field-label">领取概率</div>
              <div class="range-field-content">
                <van-field class="range-input" 
                  v-model="rangeItem.percent"
                  placeholder="保留两位小数" 
                  type="number"
                  :readonly="isReadonly"
                  @blur="checkDecimalPlaces('percent', rangeItem)">
                  <span slot="right-icon">%</span>
                </van-field>
              </div>
            </div>
          </div>
        </div>
        <div class="add-range-btn" @click="addRange" v-if="!isReadonly">
          <van-icon name="plus" />
          添加区间
        </div>
      </template>
    </template>
    
    <!-- <div class="footer" v-if="sourceType == 2">
      <div class="total-box">
        <span class="total-fee-label">剩余金额：</span>
        <span class="total-fee-value">{{totalAmount}}元</span>
      </div>
      <div class="attention-box">
        <div>注意事项：</div>
        <div>1. 微信充值将会收取一定的手续费</div>
        <div>2. 剩余红包金额将在活动结束后原路退回</div>
      </div>
      <div class="btn-box">
        <template v-if="isReadonly">
          <div class="recharge-btn" @click="showRecharge">充值</div>
          <div class="recharge-record-btn" @click="jumpRecord('/recharge-records')">充值记录</div>
        </template>
        <div class="recharge-record-btn" @click="jumpRecord('/usage-record')">使用记录</div>
      </div> 
    </div> -->

    <recharge-dialog v-if="isShowRecharge" :visible.sync="isShowRecharge" />
    <van-action-sheet 
      v-model="isShowPopover" 
      :actions="redPacketTypeOptions" 
      close-on-click-action 
      @select="onSelectType"
      cancel-text="取消"
    />
  </div>
</template>

<script>
import RechargeDialog from './recharge-dialog'
import {round2Places} from '@/utils/utils'
export default {
  components: {
    RechargeDialog
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    // 1:创建  2:附加
    sourceType: Number,
    // 是否已配置了红包
    isConfigured: Boolean,
    // 红包金额
    totalAmount: Number,
    createdTime: [String, Number]
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isReadonly() {
      return this.$route.query.activityStatus == 3 || (this.sourceType == 2 && this.isConfigured);
    },
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      form: {
        boolShowRedPacket: false,
        boolAreaLimited: false,
        boolRedPacketRolling: false,
        boolInternalStaffLimit: false,
        redPacketType: '1',
        singleAmount: '',
        totalAmount: '',
        ranges: [
          {
            startAmount: '',
            endAmount: '',
            percent: ''
          }
        ]
      },
      redPacketTypeOptions: [
        { name: '普通红包', value: 1 },
        { name: '随机红包', value: 2 },
      ],
      isShowPopover: false,
      isShowRecharge: false,
      withdrawConfig: {}
    }
  },
  mounted() {
    this.queryPublicityData()
  },
  methods: {
    initForm(val) {
      if (val) {
        this.form = {...val};
      }
    },
    onFormChange(type = '') {
      // if (this.creationMode) {
        // 当前创建时间大于项目上线时间时为新活动
        const {openRechargeAndWithdraw, time} = this.withdrawConfig
        let createdTime = this.sourceType != 2 ? new Date().getTime() : new Date(this.createdTime).getTime()
        const isNewActive = createdTime > new Date(time).getTime()
        if (type == 'red' && openRechargeAndWithdraw === 'false' && isNewActive) {
          this.form.boolShowRedPacket = false
          this.$dialog.alert({
            title: '提示',
            message: '系统维护中当前不可配置现金红包',
          })
            .then(() => {
              // on confirm
            })
          return
        // }
      }
      this.$emit('change', this.form);
    },
    onSelectType(option) {
      this.form.redPacketType = option.value;
      this.onFormChange();
    },
    addRange() {
      this.form.ranges.push({
        startAmount: '',
        endAmount: '',
        percent: ''
      });
    },
    deleteRange(index) {
      this.form.ranges.splice(index, 1);
      this.onFormChange();
    },
    // 普通红包
    checkCommonValid() {
      const invalidLabels = [];
      if (!this.form.singleAmount || this.form.singleAmount == 0) {
        invalidLabels.push('红包单个金额');
      }
      if (!this.form.totalAmount || this.form.totalAmount == 0) {
        invalidLabels.push('红包首次充值金额');
      }
      if (invalidLabels.length) {
        this.$notify({
          message: `${invalidLabels.join('、')}不能为空和0`,
          type: 'warning'
        });
        return false;
      }
      /* if (+this.form.singleAmount > +this.form.totalAmount) {
        this.$notify({
          message: '红包单个金额不能大于首次充值金额',
          type: 'warning'
        });
        return false;
      } */
      return true;
    },
    // 随机红包
    checkRandomValid() {
      const invalidMsgs = [];
      if (!this.form.totalAmount || this.form.totalAmount == 0) {
        invalidMsgs.push('红包首次充值金额不能为空和0');
      }
      // 区间配置有一个字段为空
      const hasEmpty = this.form.ranges.some(item => item.startAmount === '' || item.endAmount === '' || item.percent === '');
      if (hasEmpty) {
        invalidMsgs.push('红包区间字段不能为空');
      }

      if (invalidMsgs.length) {
        this.$notify({
          message: invalidMsgs.join('\n'),
          type: 'warning'
        });
        return false;
      }

      // 区间配置错误：开始大于等于结束
      const amountInvalid = this.form.ranges.some(item => +item.startAmount >= item.endAmount);
      if (amountInvalid) {
        this.$notify({
          message: '红包金额区间配置错误',
          type: 'warning'
        });
        return false;
      }

      // TODO 区间交叉暂不校验

      return true;
    },
    checkValid() {
      // 未开启红包
      if (!this.form.boolShowRedPacket) {
        return true;
      }    
      // 普通红包
      if (this.form.redPacketType == 1) {
        return this.checkCommonValid();
      } else if (this.form.redPacketType == 2) {
        // 随机红包
        return this.checkRandomValid();
      }
      return true;
    },
    jumpRecord(path) {
      this.$router.push({
        path,
        query: {
          activityId: this.$route.query.activityId
        }
      })
    },
    showRecharge() {
      this.isShowRecharge = true;
    },
    checkFeeValid(fieldName, form) {
      const model = form || this.form;
      const fieldValue = model[fieldName];
      model[fieldName] = fieldValue < 0.3 ? 0.3 : round2Places(fieldValue);
      this.onFormChange();
    },
    checkDecimalPlaces(fieldName, form) {
      const model = form || this.form;
      if (fieldName == 'totalAmount') {
        const fieldValue = model[fieldName];
        model[fieldName] = fieldValue < 0.3 ? 0.3 : round2Places(fieldValue);
      }else {
        model[fieldName] = round2Places(model[fieldName]);
      }
      this.onFormChange();
    },
    queryPublicityData(){
      this.$api.h5.queryPublicityData('wx_withdraw_config')
        .then(res => {
          if (res.success) {
            const {openRechargeAndWithdraw, time} = res.data
            this.withdrawConfig = {openRechargeAndWithdraw,time}
          }
        })
    }
  },
  filters: {
    redPacketTypeEnum(val) {
      const map = {
        1: '普通红包',
        2: '随机红包',
      };
      return map[val]
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px
  .collapse-item
    >>> .van-collapse-item__title .van-cell__title
      font-weight 600
    >>> .van-collapse-item__content
      padding 0
      .van-cell__title
        color #909399

.card
  margin 15px 0
  overflow: hidden
  border-radius: 8px

.field-item
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    color #323233

.fee-value
  >>> .van-cell__value input
    text-align: right

.range-card
  margin 15px 0
  padding 10px 16px
  background-color: #fff
  border-radius: 8px
  &-head
    padding-bottom 10px
    display: flex
    justify-content: space-between
    font-size 14px
    font-weight 600

.range-field
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 0
  font-size 14px
  &-label
    color #606266
    flex none
  &-content
    display: flex
    align-items: center
    justify-content: space-around

    >span 
      margin 0 10px

    .range-input
      padding 0
      line-height 1
      &::after
        border-bottom: none
      >>> .van-field__body
        width 105px
        input
          border-bottom: 1px solid #ebedf0
          text-align: center

.footer
  .total-box
    margin 30px 0 20px
    text-align: center
    color #333
    font-weight bold
    .total-fee-label
      font-size 24px
    .total-fee-value
      color $mainTextColor
      font-size 24px
  .btn-box
    display flex
    flex-direction: column
    align-items: center
    margin 20px 0
    text-align: center
    .recharge-btn
      display: inline-block
      padding 10px 45px
      background-color: $mainTextColor 
      border-radius 4px
      color #fff
      font-size 18px
    .recharge-record-btn
      display inline-block
      margin-top 10px
      padding 5px
      color $mainTextColor
      width 100px
  .attention-box
    margin 30px 0
    padding 0 10px
    line-height 1.5

.add-range-btn
  margin 15px 0
  padding 10px 0
  text-align: center
  color $mainTextColor
  font-size 14px
  font-weight 600
  border 1px solid $mainTextColor
  border-radius 8px
  >>> .van-icon
    font-weight 600
  span
    margin-left 5px
.tips
  padding 0 16px 5px
  font-size 12px
  color #bbb
  text-align: right
.tips-bg
  background-color: #fff

.radius
  border-radius: 8px
.top-radius
  border-top-left-radius 8px
  border-top-right-radius 8px
.bottom-radius
  border-bottom-left-radius 8px
  border-bottom-right-radius 8px

.mt-mb-15
  margin 15px 0
.margin-15
  margin 15px
.mt-5
  margin-top 5px
.bold
  font-weight 600
</style>
<style lang="stylus">
.van-popup .van-popover__content .van-popover__action
  width 100px
</style>